import { COUNTRIES } from "../../../../constants/countries";
import { BranchSettings } from "../../../../services/dto/request/branches-request-dto";

/**
 * Obtiene los valores iniciales de configuración de sucursal según el país
 * Esto permite que cada país tenga sus propios valores por defecto sin llenar
 * el componente principal de condicionales
 */
export const getInitialBranchSettings = (countryCode: string): BranchSettings => {
  const commonSettings = {
    googleReviewLink: "",
    identityNumber: "",
    personType: "LEGAL" as const,
    isTaxPayer: false,
    equalSplitTip: false,
  };

  switch (countryCode) {
    case COUNTRIES.DO: // República Dominicana
      return {
        ...commonSettings,
        onlyRatings: false,
        identityType: "CUIT", // Valor por defecto (no se usa en RD)
        createCBU: false, // RD no requiere cuenta de propinas
      };

    case COUNTRIES.AR: // Argentina
    default:
      return {
        ...commonSettings,
        onlyRatings: false,
        identityType: "CUIT",
        createCBU: true, // AR sí puede crear cuenta de propinas
      };
  }
};

